import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { FontWeights } from '../../enums/font-weights';
import { TextSizes } from '../../enums/typography-text-sizes';
import { cn } from '../../utils/cn';
import { textVariants } from '../../variants/typography-text-variants';
import type { TextProps } from './types';

const Text = React.forwardRef<HTMLElement, TextProps>(
  (
    {
      as: Component = 'span',
      asChild = false,
      className,
      size = TextSizes.SM,
      weight = FontWeights.REGULAR,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : Component;
    return (
      <Comp
        ref={ref}
        data-slot='typography-text'
        className={cn('antialiased', textVariants({ size, weight }), className)}
        data-size={size}
        data-weight={weight}
        {...props}
      />
    );
  }
);
Text.displayName = 'Text';

export { Text };
